import { useEffect } from "react";
import Lenis from "lenis";
import { useMotionPreferences } from "../hooks/use-motion-preferences";

const LENIS_DISABLED =
  typeof window !== "undefined" &&
  window.location.search.includes("nolenis=1");

export default function SmoothScroll({ children }) {
  const { prefersReducedMotion } = useMotionPreferences();

  useEffect(() => {
    if (prefersReducedMotion || LENIS_DISABLED) return;

    const lenis = new Lenis({
      duration: 1.05,
      easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
      smoothWheel: true,
      smoothTouch: false,
    });

    if (typeof window !== "undefined") {
      window.__lenis = lenis;
    }

    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);

    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
      if (typeof window !== "undefined") {
        delete window.__lenis;
      }
    };
  }, [prefersReducedMotion]);

  return children;
}
